import React from 'react';

import {asClassComponent} from '/util/hoc.util';

import {StorybookContext} from './StorybookProvider';

export default (Component: any) =>
  asClassComponent((props: any) => (
    <StorybookContext.Consumer>
      {storybookProps => <Component {...props} {...storybookProps} />}
    </StorybookContext.Consumer>
  ));
